<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('closeModal')">
                <div class="row">
                    <div class="col-xs-0 col-sm-0 col-md-1 col-lg-3"></div>
                    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-6">
                        <div class="modal-container" @click.stop>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-8">
                                        <h2
                                            class="title"
                                            style="margin-bottom: 20px"
                                        >
                                            Confirm Multiple Dealer Request
                                        </h2>
                                    </div>
                                    <div class="offset-3 col-1">
                                        <button
                                            type="button"
                                            class="close"
                                            @click="$emit('closeModal')"
                                            style="
                                                font-size: 20px;
                                                color: #db5757;
                                                opacity: 1;
                                            "
                                        >
                                            <i class="fa fa-times" style="font-weight: 0 !important;"></i>
                                        </button>
                                    </div>
                                </div>

                                
                                <span style="font-size:14px">Dealer Selected<br></span>
                                <div class="container-flex mt-2">
                                    <div v-for="(dealer , index) in data.dealer" class="container-flex-child container-flex-between">
                                        <div>{{ dealerList.find(x => x.loc_code == dealer).showName }}</div>
                                        <div>
                                            <button
                                                type="button"
                                                class="close"
                                                @click="removeDealer(index)"
                                                style="
                                                    font-size: 14px;
                                                    color: #000;
                                                    opacity: 1;
                                                "
                                            >
                                                <i class="fa fa-times"></i>
                                            </button>
                                        </div>
                                        
                                    </div>
                                </div>

                                <!-- {{ data }} -->

                                <div class="container-flex-between mt-3">
                                    <div>Durasi</div>
                                    <div>{{duration }}</div>
                                </div>
                                <div class="container-flex-between mt-3">
                                    <div>Tanggal</div>
                                    <div>{{moment(data.tgl_request).format('DD MMMM Y') }}</div>
                                </div>
                                <div class="container-flex-between mt-3">
                                    <div>Jam</div>
                                    <div>{{moment(data.tgl_request).format('HH:mm:ss') }} WIB</div>
                                </div>

                                <div class="row mt-4">
                                    <div class="col-lg-4 col-6 offset-lg-4">
                                        <button
                                            class="btn btn-dark-blue-outline w-100"
                                            @click="$emit('closeModal')"
                                        >
                                            Batal
                                        </button>
                                    </div>
                                    <div class="col-lg-4 col-6">
                                        <button
                                            class="btn btn-dark-blue w-100"
                                            @click="$emit('submit' , true)"
                                        >
                                            Kirim Perintah
                                        </button>
                                    </div>
                                </div>
                                <!-- {{ data }} -->
                                <!-- Button Starts -->
                                
                                <!-- Button Ends -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-0 col-sm-0 col-md-1 col-lg-3"></div>
            </div>
        </div>
    </transition>
</template>

<script>
import { timingSafeEqual } from 'crypto';
import moment from 'moment'
export default {
    data() {
        return {
            dealerList : this.$store.getters.getFilterOptions.dealer,
            duration : null,
            moment
        };
    },
    mounted () {
        var hours = Math.floor(this.data.durasi / 60);          
        var minutes = this.data.durasi % 60;
        this.duration = hours + ' Jam ' + minutes + ' Menit'
    },
    props : ['data'],
    methods : {
        removeDealer (index) {
            this.data.dealer.splice(index,  1)
            this.$emit('removeDealer' , index)
        }
    }
};
</script>

<style scoped>
/* ==========================================================================
	#FORM made by Colorlib (https://colorlib.com)
	========================================================================== */
input {
    outline: none;
    margin: 0;
    border: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    width: 100%;
    font-size: 14px;
    font-family: inherit;
}

.input--style-4 {
    line-height: 40px;
    background: #fff;
    /* -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08); */
    border : 1px solid #CECECE;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    padding: 0 20px;
    font-size: 16px;
    /* color: #666; */
    -webkit-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #CECECE;
}

.input--style-4:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #CECECE;
    opacity: 1;
}

.input--style-4::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #CECECE;
    opacity: 1;
}

.input--style-4:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #CECECE;
}

.input--style-4:-ms-input-placeholder {
    /* Microsoft Edge */
    color: #CECECE;
}

.label {
    font-size: 12px;
    color: #5D5D5D;
    text-transform: capitalize;
    display: block;
    margin-bottom: 5px;
}

.radio-container {
    display: inline-block;
    position: relative;
    padding-left: 30px;
    cursor: pointer;
    font-size: 16px;
    color: #666;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.radio-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
    background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
    display: block;
}

.radio-container .checkmark:after {
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    background: #57b846;
}

.checkmark {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #e5e5e5;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
    content: '';
    position: absolute;
    display: none;
}

.input-group {
    position: relative;
    /* margin-bottom: 22px; */
    padding: 20px;
}

.input-group-icon {
    position: relative;
}

.input-icon {
    position: absolute;
    font-size: 18px;
    color: #999;
    right: 18px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    cursor: pointer;
}

/* ==========================================================================
	#TITLE made by Colorlib (https://colorlib.com)
	========================================================================== */
.title {
    font-size: 16px;
    color: #525252;
    margin-bottom: 40px;
    text-align: center;
}

.modal-body {
    max-height: 80vh;
    overflow-y: auto;
    overflow-x: auto;
}
.innerBox {
    padding: 1.5rem 1.5rem 1.5rem 2.25rem;
    border: 1px solid #eeeeee;
    border-radius: 5px;
    background-color: white;
    box-shadow: 2px 2px 5px #e0e0e0;
}
.custom-control {
    margin-bottom: 0;
}

.hoverable:hover {
    cursor: pointer;
}
.input-group {
    padding-left: 0;
    padding-right: 0;
}

.first-field {
    padding-right: 3.5%;
}

.second-field {
    padding-left: 3.5%;
}
.flex-middle {
	text-align: center;
}

.container-flex {
    display: flex;
    flex-wrap: wrap;
}
.container-flex-child {
  margin-right:1em;  /* Magic! */
  border: 1px solid #CECECE;
  padding: 8px;
  border-radius: 5px;
  margin-bottom: 3px;
}
.container-flex-between {
    display:flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
}
</style>
